import React from 'react'

import Link from 'next/link'
import {palette} from 'styled-tools'
import styled from 'styled-components'
import {SearchResponse} from '@algolia/client-search'
import NewspaperLineIcon from 'remixicon-react/NewspaperLineIcon'

import {H5, P} from '@festi/common/components/typography'
import {AdviceSuggestions} from 'src/components/search/redesign/utilites/quickSearch'

const Wrapper = styled.div``

const Categories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Category = styled(Link)`
  display: flex;
  gap: 16px;

  .remixicon-icon {
    fill: ${palette('ui40Solid')};
  }
`

interface HitsProps {
  adviceResults?: SearchResponse<AdviceSuggestions>
}

export default function AdviceHits({adviceResults}: HitsProps) {
  return (
    <Wrapper>
      <H5 withGutter>Ráðleggingar</H5>

      <Categories>
        {adviceResults?.hits?.map((hit) => (
          <Category key={hit.id} href={`/voruflokkar/${hit.slug}`}>
            <NewspaperLineIcon />
            <P bold>{hit.name}</P>
          </Category>
        ))}
      </Categories>
    </Wrapper>
  )
}
